import React, { useMemo } from 'react';

import { useFormContext, useWatch } from 'react-hook-form';

import { templateStudioStateService } from 'state/template-studio.state.service';
import { z } from 'zod';

import { EThemes } from 'components/TemplatesStudio/enums';
import { BlockMetadata } from 'components/TemplatesStudio/DesignsMetadata/types';

import { templateStudioSchema } from '../../../validation-schema';
import { DesignSidebarItem } from '../Components/DesignSidebarItem';

const TRIGGERED_POPUPS_OBJECT_PATH = 'triggeredPopups';

const getTriggeredPopupsBadgeDesignsByFilter = ({
  themes
}: {
  themes: EThemes[];
}): BlockMetadata[] => {
  const relevantDesigns =
    templateStudioStateService.relevantTriggeredPopupsBadgeDesigns.get() || [];

  return relevantDesigns.filter((currentDesign) => {
    return (
      !themes || themes.length === 0 || themes.includes(currentDesign.theme)
    );
  });
};

const getTriggeredPopupsDesignsByFilter = ({
  themes
}: {
  themes: EThemes[];
}): BlockMetadata[] => {
  const relevantDesigns =
    templateStudioStateService.relevantTriggeredPopupsDesigns.get() || [];

  return relevantDesigns.filter((currentDesign) => {
    return (
      !themes || themes.length === 0 || themes.includes(currentDesign.theme)
    );
  });
};

export const TriggeredPopupsBadgeSecondarySidebar: React.FC = () => {
  const { control } = useFormContext<z.infer<typeof templateStudioSchema>>();

  const triggeredPopupsObject = useWatch({
    control,
    name: TRIGGERED_POPUPS_OBJECT_PATH
  });

  const themes = triggeredPopupsObject?.themes ?? [];

  const designs = useMemo(() => {
    return getTriggeredPopupsBadgeDesignsByFilter({ themes });
  }, [themes]);

  return (
    <React.Fragment>
      {designs.map((design) => (
        <DesignSidebarItem
          key={design.id}
          {...design}
          blockDesignIdPath="triggeredPopups.selectedBadgeDesignId"
        />
      ))}
    </React.Fragment>
  );
};

export const TriggeredPopupsDesignsSecondarySidebar: React.FC = () => {
  const { control } = useFormContext<z.infer<typeof templateStudioSchema>>();

  const triggeredPopupsObject = useWatch({
    control,
    name: TRIGGERED_POPUPS_OBJECT_PATH
  });

  const themes = triggeredPopupsObject?.themes ?? [];

  const designs = useMemo(() => {
    return getTriggeredPopupsDesignsByFilter({ themes });
  }, [themes]);

  return (
    <React.Fragment>
      {designs.map((design) => (
        <DesignSidebarItem
          key={design.id}
          {...design}
          blockDesignIdPath="triggeredPopups.selectedDesignId"
        />
      ))}
    </React.Fragment>
  );
};
